const config = {
  logoPath: require("./Images/navBar-logo.png"),
  logoName: "Pennsylvania Insurance Department",
  cognito: {
    responseType: "code",
  },

  // leaving roles undefined means all roles have access to the feature
  // leaving roles empty means all roles have access to the feature
  FEATURE_FLAGS: {
    DASHBOARDS: {
      enabled: true,
      roles: [
        "client-pid",
        "admin"
      ],
    },
    DATA_UPLOAD: {
      enabled: true,
      roles: [
        "pid-cbc",
        "pid-centene",
        "pid-cigna",
        "pid-geisinger",
        "pid-highmark",
        "pid-jefferson_health_plan",
        "pid-ibc",
        "pid-oscar",
        "pid-united",
        "pid-upmc",
        "admin",
        "pbm-anaservices",
        "pbm-benecard",
        "pbm-capitalrx",
        "pbm-caremarkpcs",
        "pbm-empirx",
        "pbm-express-scripts",
        "pbm-fairosrx",
        "pbm-illuminate",
        "pbm-lifetime",
        "pbm-maven-clinic",
        "pbm-maxorplus",
        "pbm-navitus",
        "pbm-optumrx",
        "pbm-performrx",
        "pbm-prime-therapeutics",
        "pbm-radiant-service",
        "pbm-rxsense",
        "pbm-sagility",
        "pbm-smith-health-inc",
        "pbm-truerx",
        "pbm-universal-rx",
        "pbm-ventegra-foundation",
        "pbm-ventegra-inc",
        "pbm-verus",
        "pbm-welldynerx",
      ],
      maxFileSize: 150 * 1024 * 1024,
    },
    DATA: {
      enabled: true,
      firstYearInDataTable: 2025,
      roles: [
        "admin",
        "client-pid",
      ],
    },
    REPORT: {
      enabled: false,
    },
    ADMIN: {
      enabled: false,
    },
    CRITERIA_MANAGEMENT: {
      enabled: true,
      roles: [
        "admin",
        "client-pid",
      ],
    },
    EDIT_MINIMUM_PROVIDERS: {
      enabled: true,
      roles: [
        "admin",
        "client-pid",
      ]
    },
    EDIT_HIERARCHY: {
      enabled: true,
      roles: [
        "admin",
        "client-pid",
      ]
    },
  }
};

export default config;
